module.exports = __webpack_public_path__ + "static/media/feather-webfont.2cf523cd.woff";